module.exports = __webpack_public_path__ + "static/media/what_left.18f3e5bb.png";